(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDialogController', SoggettoEsternoDialogController);

    SoggettoEsternoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SoggettoEsterno', 'legislature'];

    function SoggettoEsternoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SoggettoEsterno, legislature) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.clear = clear;
        vm.save = save;
        vm.legislature = legislature;
        vm.selectedLegislature = {};
        
        if (vm.soggettoEsterno.legislature) {
            vm.soggettoEsterno.legislature.forEach(function(legislatura) {
                vm.selectedLegislature[legislatura] = true;
            });
        }
        
        $scope.$watch('vm.selectedLegislature', function() {
            vm.soggettoEsterno.legislature = Object.keys(vm.selectedLegislature)
                .filter(function(key) {
                    return vm.selectedLegislature[key];
                });
        }, true);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.soggettoEsterno.id !== null) {
                SoggettoEsterno.update(vm.soggettoEsterno, onSaveSuccess, onSaveError);
            } else {
                SoggettoEsterno.save(vm.soggettoEsterno, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:soggettoEsternoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
